import { Component, OnInit ,ViewChild, ElementRef } from '@angular/core';
import { EChartsOption } from 'echarts';
import * as echarts from 'echarts';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder, NgForm, FormArray } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-performance-appraisal',
  templateUrl: './performance-appraisal.component.html',
  styleUrls: ['./performance-appraisal.component.css']
})
export class PerformanceAppraisalComponent implements OnInit {

  EChartOption: any
  chartOptions: any 
  get_data: any
  group_topic = [] as any

  group_year = [] as any
  raw_json=[] as any
  series_chart = [] as any
  topic_chart = [] as any
  year_chart = [] as any
  indi : any;

  page = 1;
  count = 0;
  tableSize = 15;
  
  constructor(
    public services: ApiService
  ) { }

  ngOnInit(): void {
    document.getElementById('performance-c')!.classList.toggle("active");
    this.get_dataCharts();
  }
  
  ngOnDestroy(){
    if(document.getElementById('performance-c')){
      document.getElementById('performance-c')!.classList.remove("active");
    }
  }

  get_dataCharts(){
    this.services.getIndicators().then((res: any) => {

      let gr_year = res.reduce(function (r:any, row:any) {
        r[row.ysers] = ++r[row.ysers] || 1;
        return r;
      }, {});


      this.group_year = Object.keys(gr_year).map(function (key) {
          return { years: key, value: gr_year[key] };
      }).sort();

      this.group_year.sort(function (a:any, b:any) {
        return a.years - b.years;
      });
      
      this.group_year.forEach((e:any) => {
        this.year_chart.push(e.years)
      });
    
      let grpData = res.reduce((acc:any, cv:any) => {
          if (!acc[cv.ysers]) {
              acc[cv.ysers] = {};
              acc[cv.ysers].ysers = cv.ysers;
              acc[cv.ysers].count = acc[cv.ysers].score = 0
          }
          acc[cv.ysers].count++;
          acc[cv.ysers].score += Number(cv.score);
          return acc;
      }, {});
      grpData = Object.keys(grpData).map(key => {
          let { score , count } = grpData[key];
          return Number((score / count).toFixed(2)) ;
      })
      
      let max_topic = Math.max.apply(Math, this.group_year.map(function (o:any) { return o.value; }));
      let max_year = Math.max.apply(Math, this.group_year.map(function (o:any) { return o.years; }));
      
      for (let i = 0; i < max_topic; i++) {
        let topic = 'ด้านที่ '+(i+1)
        let concat_year = [] as any , test2 = [] as any , data_chart = [] as any,num = 0
        this.topic_chart.push(topic)
        for (let j = 0; j < this.group_year.length; j++) {
          const e = this.group_year[j];
           res.forEach((f:any) => {
            if(topic == f.topic && e.years == f.ysers){
              concat_year.push({year : e.years , score : f.score }) 
              data_chart.push([j , Number(f.score) ])
            }
          });

          let test = concat_year.find((f:any)=>{ return f.year == e.years   })
          if (test == undefined) {
            test2.push({year : e.years , score : '' })
          }else{
            test2.push(test)
          }
        }
        this.series_chart.push({
          name: topic,
          type: 'bar',
          data: data_chart
        })

        this.raw_json.push({topic: topic,value:test2})
      }
        this.series_chart.push({
          name: 'ผลเฉลี่ย',
          type: 'line',
          color: '#000000',
          yAxisIndex: 1,
          data: grpData,
        })
      this.raw_json.forEach((e:any) => {
        let test3 = res.find((f:any)=>{ return e.topic== f.topic && f.ysers ==  max_year  })
        if (test3 == undefined) {
          e.topic = ''
        }else{
          e.topic = e.topic +' '+ test3.topic_name
        }
      });

      this.EChartOption = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
              type: 'cross',
              crossStyle: {
                  color: '#999'
              }
          }
      },
  
      legend: {
          data: this.topic_chart
      },
      xAxis: [
          {
              type: 'category',
              data: this.year_chart,
              axisPointer: {
                  type: 'shadow'
              }
          }
      ],
      yAxis: [
          {
              type: 'value',
              name: 'ผลกาารดำเนินงานของทุนหมุนเวียน',
              min: 0,
              max: 10,
              interval: 2,
              axisLabel: {
                  formatter: '{value} '
              }
          },
          {
              type: 'value',
              name: 'ค่าเฉลี่ยผลกาารดำเนินงานของทุนหมุนเวียน',
              min: 0,
              max: 10,
              interval: 2,
              axisLabel: {
                  formatter: '{value} '
              }
          }
      ],
      series: this.series_chart
      }

    });
    this.services.g_Pindi().then((res: any) => {

      res.sort(function (a:any, b:any) {
        return a.years - b.years;
      });

      this.indi = res
      
    })
  }

  onTableDataChange(event: any) {
    this.page = event;
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

}
